import React from "react";
import { Tldraw } from "@tldraw/tldraw";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Tldraw />
    </div>
  );
}

export default App;
